import { Component, Input } from '@angular/core';
import { CmsSeoContentComponent } from '@kion/data-models';

@Component({
  selector: 'kion-cms-seo-content',
  templateUrl: './seo-content.component.html',
  styleUrls: ['./seo-content.component.scss']
})
export class SeoContentComponent {

  @Input() component: CmsSeoContentComponent;

  get imageBackground(): string {
    return this.component.background === 'GREY' ? 'eeeff3' : 'fff'
  }
}
